const mockStatus = async () => {
    // status can be SUCCEEDED || FAILED || RUNNING || TIMED_OUT || ABORTED
    const result = {
        status: 'RUNNING',
        startDate: new Date(),
        stopDate: new Date(), // new Date(1556668800),
    };

    return result;
};

const mockPublish = async venueId => {
    return Promise.resolve(`Publish venue: ${venueId}`);
};

const MockAssets = {
    publish: async () => mockPublish(),
    getPublishStatus: async () => mockStatus(),
    getPublishFreeze: async () => ({ frozen: false }),
};

export { MockAssets };
